var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"height":_vm.size,"viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.364 5.046L5.68201 9.72798L1.00002 5.046","stroke":_vm.color,"stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }